import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (typeof this.props.onError === 'function') {
      this.props.onError(error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', color: '#e2e8f0', textAlign: 'center' }}>
          <div>
            <h1 style={{ fontSize: '1.4rem', marginBottom: '0.75rem' }}>Something went wrong</h1>
            <p style={{ color: '#94a3b8', marginBottom: '1.25rem' }}>
              Reload the page. If it keeps happening, email livenow.enterprise@gmail.com.
            </p>
            <button
              type="button"
              className="livenow-signup-btn"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
